import PrimaryLayout from './primary.layout'

export default PrimaryLayout
